<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    :showNesteds="showNesteds"
    :createButtonDisabled="!$can('create','Route')"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :showNesteds="showNesteds"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    showNesteds: {
      type: Boolean,
      default: true,
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;      
      this.$apollo
        .query({
          query: LOAD_NEW_ROUTE_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.route;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => {
          this.loading = false;          
        });
    },
    createServerEntry: function(route) {
      // console.log("FIELD", route, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(route, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_ROUTE_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(route, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createRoute.errors

          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createRoute.route);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_ROUTE_QUERY = gql `
  {
    accountContext {
      route {
        name        
        description
        validations
        personIdsAttribute
        people{
          id
          name
        }
      }

      allCustomers{
        id
        name
      }
    }    
  }
`;

const CREATE_ROUTE_MUTATION = gql `
  mutation($input: RouteCreateInputObject!) {
    createRoute(input: $input) {
      route {
        id
        name
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
